import {Distance} from '../Domain/Distance';
import {Force} from '../Domain/Force';
import {Curve} from '../Models/Curve';

export interface CurveMetrics {
    rSquaredTotalStroke: number;
    rSquaredPrePeak: number;
    rSquaredPostPeak: number;
}

export function calculateCurveMetrics(
    strokeLength: Distance | null,
    peakForce: Force | null,
    peakForcePosition: Distance | null,
    curve: Curve | null,
    referenceCurve: Curve | null,
): CurveMetrics {
    if (
        curve === null ||
        strokeLength === null ||
        peakForce === null ||
        peakForcePosition === null ||
        referenceCurve === null
    ) {
        // Handle the case when curve is null, you can return null or provide a default value.
        return {rSquaredTotalStroke: 0, rSquaredPrePeak: 0, rSquaredPostPeak: 0};
    }

    let sumSquareResiduals = 0.0;
    let sumSquareTotals = 0.0;
    let sumSquareResidualsPre = 0.0;
    let sumSquareTotalsPre = 0.0;
    let sumSquareResidualsPost = 0.0;
    let sumSquareTotalsPost = 0.0;

    const n = curve.length;
    const curveMean = curve.reduce((sum, point) => sum + point.y, 0) / n;

    for (const referencePoint of referenceCurve) {
        const point = curve.find((p) => p.x === referencePoint.x);
        if (point === undefined) {
            continue;
        }
        sumSquareResiduals += Math.pow(point.y - referencePoint.y, 2.0);
        sumSquareTotals += Math.pow(point.y - curveMean, 2.0);

        // find if the point is pre peakForce
        if (referencePoint.x <= peakForcePosition.centimeters) {
            sumSquareResidualsPre += Math.pow(point.y - referencePoint.y, 2.0);
            sumSquareTotalsPre += Math.pow(point.y - curveMean, 2.0);
        }
        // or post peakforce
        else {
            sumSquareResidualsPost += Math.pow(point.y - referencePoint.y, 2.0);
            sumSquareTotalsPost += Math.pow(point.y - curveMean, 2.0);
        }
    }
    return {
        rSquaredTotalStroke: 1 - sumSquareResiduals / sumSquareTotals,
        rSquaredPrePeak: 1 - sumSquareResidualsPre / sumSquareTotalsPre,
        rSquaredPostPeak: 1 - sumSquareResidualsPost / sumSquareTotalsPost,
    };
}
